// documentConfig.js

import { fetchEmployeeDetails } from '../services/Service';
//import '@ant-design/v5-patch-for-react-19';

import { Popconfirm, Tooltip, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import labels from '../util/labels.json';

// Toast config (you can adjust this globally in your app's entry point)
export const configureToast = () => {
  toast.configure({
    autoClose: 3000,
    limit: 3,
    pauseOnHover: true,
    position: 'top-right',
  });
};

// Success notification
export const showNotification = (message) => {
  toast.success(message, {
    position: 'top-right',
    autoClose: 3000,
    style: {
      fontSize: '16px',
      padding: '16px',
      lineHeight: '1.6',
      borderRadius: '8px',
      background: '#f0fff4',
      color: '#2f855a',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    },
    
  });
};

// Error notification
export const showErrorNotification = (message) => {
  toast.error(message, {
    position: 'top-right',
    autoClose: 3000,
    style: { fontSize: '16px' },
  });
};

// Warning notification
export const showWarningNotification = (message) => {
  toast.warn(message, {
    position: 'top-right',
    autoClose: 3000,
    style: { fontSize: '16px' },
  });
};


/*notification.config({
    placement: 'topRight',
    top: 80,
    duration: 3,
    maxCount: 3,
  });
  
  export const showNotification = (message) => {
    notification.success({
      message: 'Success',
      description: message,
      style: { fontSize: '16px' }, // Adjust the font size here
    });
  };
  export const showErrorNotification = (message) => {
    notification.error({
      message: 'Error',
      description: message,
      style: { fontSize: '16px' }, // Adjust the font size here
    });
  };
  export const showWarningNotification = (message) => {
    notification.warning({
      message: 'Warning',
      description: message,
      style: { fontSize: '16px' }, // Adjust the font size here
    });
  };*/

  export const fetchEmployeeData = async (email) => {
    
    try {
      let response;
      
        //console.log('Fetching by email');
        response = await fetchEmployeeDetails(email);
       
      
      //console.log(response);
      return response.uid;
    } catch (error) {
      console.error('An Error Occurred:', error);
    }
  };
  
  export const DeleteConfirmButton = ({
    title = "Are you sure you want to delete this record?",
    onConfirm,
    onCancelMessage = "Delete action was cancelled.",
    buttonLabel = "Delete",
    buttonStyle = {},
    icon = <DeleteOutlined />,
    tooltip = "Delete"
  }) => {
    return (
      <Tooltip title={tooltip}>
        <Popconfirm
          title={title}
          okText="Yes"
          cancelText="No"
          onConfirm={onConfirm}
          onCancel={() =>
            toast.warn(onCancelMessage, {
              position: "top-right",
              autoClose: 3000,
              style: { fontSize: "16px" },
            })
          }
        >
           <Button
                        type="danger"
                        icon={<DeleteOutlined />}
  
                        style={{ marginLeft: "8px", color: "red" }}
                      >
                        {buttonLabel}
                      </Button>
         
        </Popconfirm>
      </Tooltip>
    );
        };

    export const SendEmailConfirmButton = ({
      title = labels.confirmation,
      onConfirm,
      onCancelMessage = "Sending Email Cancelled",
      buttonLabel = labels.sendEmailButton,
      tooltip = "Send Email"
    }) => {
      return (
        <Tooltip title={tooltip}>
          <Popconfirm
            title={title}
            okText="Yes"
            cancelText="No"
            onConfirm={onConfirm}
            onCancel={() =>
              toast.warn(onCancelMessage, {
                position: "top-right",
                autoClose: 3000,
                style: { fontSize: "16px" },
              })
            }
          >
          <Button type="primary" className="bg-[#183D5D] text-white rounded-full px-5 py-5 text-xl flex items-center gap-4 shadow-xl">
                          {buttonLabel}
                        </Button>
          </Popconfirm>
        </Tooltip>
      );
  };
  
